module.exports = __webpack_public_path__ + "static/media/section6.4161b731.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quiz/image/section6.png
// module id = 302
// module chunks = 0